export default function getMigrationReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'GET_MIGRATION_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_MIGRATION_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_MIGRATION_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}